import type { FaireProductEntity } from "../../entity_types/product";

export const p_rttgsgdct4: FaireProductEntity = {
  token: "p_rttgsgdct4",
  type: "product",
  name: "Spice and Wolf, Vol. 2",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/39f7cb9230934ac43d2f05d574257e54341b8a1041acf88cfe4ed62ae446cc2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5901439efccf9afb64fdeabf49b36f95077a298f37e624a5100b4562377595f.webp"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nNewly arrived in Pazzio, the traveling merchant Lawrence and his companion, Holo the Wisewolf, are poised to turn a huge profit on a currency scheme. But when the deal goes sour and Holo is abducted, will Lawrence's dreams of earning enough to become a proper town merchant fade? Or can this meek merchant devise a new strategy to rescue both his profits and the girl before Holo is delivered to the hands of the Church?",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:33.775Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
